import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import GMTClock from '../features/participant/calendars/GMTClock';
import 'bootstrap/dist/css/bootstrap.min.css';
import { fetchNotifications } from '@/lib/api/Notifications';
import { readUserApi } from '@/lib/api/Users';
import NotificationDropdown from './notifications/NotificationDropdown';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const TopBar = () => {
  const [user, setUser] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [ws, setWs] = useState(null);

  // Fetch user & notifications
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await readUserApi();
        setUser(userData);
      } catch (err) {
        console.error('Failed to load user data:', err);
      }
    };

    const fetchUserNotifications = async () => {
      const data = await fetchNotifications();
      setNotifications(data);
    };

    fetchUser();
    fetchUserNotifications();
  }, []);

  // WebSocket connection

  useEffect(() => {
    if (!user) return;

    const token = localStorage.getItem('authToken'); // adjust your token storage
    if (!token) return;

    // Generic WS
    const socket = new WebSocket(`${process.env.REACT_APP_WS_URL}/ws/matchmaking/generic?token=${token}`);
    // 1v1 WS
    const socket_1v1 = new WebSocket(`${process.env.REACT_APP_WS_URL}/ws/matchmaking/1v1?token=${token}`);

    setWs(socket);

    // --- Generic WS ---
    socket.onopen = () => console.log('✅ Generic WS connected');
    socket.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);

        if (msg.event === 'match_found' && msg.members) {
          const isInMatch = [...msg.members.team_a, ...msg.members.team_b].some(
            (m) => m.user_id === user.id
          );
          if (isInMatch) {
            toast.info(`🎯 Match found! Team size: ${msg.team_size}`, {
              position: 'top-right',
              autoClose: 5000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
            });
          }
        }
      } catch (err) {
        console.error('Failed to parse Generic WS message', err);
      }
    };
    socket.onclose = () => console.log('🔌 Generic WS disconnected');
    socket.onerror = (err) => console.error('❌ Generic WS error', err);

    // --- 1v1 WS ---
    socket_1v1.onopen = () => console.log('✅ 1v1 WS connected');
    socket_1v1.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);

        if (msg.event === 'match_found' && msg.message) {
          toast.info(`🎯 ${msg.message}`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } catch (err) {
        console.error('Failed to parse 1v1 WS message', err);
      }
    };
    socket_1v1.onclose = () => console.log('🔌 1v1 WS disconnected');
    socket_1v1.onerror = (err) => console.error('❌ 1v1 WS error', err);

    return () => {
      socket.close();
      socket_1v1.close();
    };
  }, [user]);

  const getProfilePath = () => {
    if (!user) return '/profile';
    if (user.is_admin) return '/admin/profile';
    if (user.account_type === 'sport_participant') return '/participant/profile';
    if (user.account_type === 'sport_organizer') return '/organizer/profile';
    return '/profile';
  };

  const getLogoPath = () => {
    if (!user) return '/';
    if (user.is_admin) return '/admin';
    if (user.account_type === 'sport_participant') return '/participant';
    if (user.account_type === 'sport_organizer') return '/organizer';
    return '/';
  };

  return (
    <>
      <div
        className="topbar d-flex justify-content-between align-items-center px-3 px-md-4 py-2 border-bottom"
        style={{
         background: 'linear-gradient(90deg, #E51110 19%, #F08400 50%, #FFF049 76%)',
         // boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        }}
      >

        <div className="flex-shrink-0">
          <Link to={getLogoPath()} className="fw-bold text-dark text-decoration-none">
            <img
              src="/images/logo.jpg"
              alt="Logo"
              style={{
                height: '40px',
                objectFit: 'cover',
              }}
            />
          </Link>

        </div>

        <div className="d-flex align-items-center gap-2 gap-md-3 flex-wrap">
          <GMTClock />
          <NotificationDropdown notifications={notifications} />
          <div
            className="fw-medium d-none d-sm-block text-truncate text-dark"
            style={{ maxWidth: '120px' }}
          >
            Hi! {user?.full_name || 'User'}
          </div>


          <Link to={getProfilePath()} className="text-decoration-none flex-shrink-0">
            {user?.profile_image ? (
              <img
                src={user.profile_image ? `${user.profile_image}?t=${Date.now()}` : '/images/avatar.png'}
                alt="Avatar"
                className="rounded-circle"
                style={{
                  width: '40px',
                  height: '40px',
                objectFit: 'cover',
               //   border: '2px solid #ccc',
                }}
              />

            ) : (
              <div
                className="bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center"
                style={{ 
                  width: '40px', 
                  height: '40px', 
                  fontWeight: 'bold'
                
                }}
              >
                {user?.full_name?.charAt(0).toUpperCase() || 'U'}
              </div>
            )}



          </Link>



        </div>
      </div>

      {/* Toast container */}
      <ToastContainer />
    </>
  );
};

export default TopBar;
